import 'polyfill';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import './index.css';
import App from 'App';
import theme from 'theme';
import * as serviceWorker from 'serviceWorker';

const root = createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider theme={theme}>
    <App />
  </ThemeProvider>
);

serviceWorker.unregister();
